<div class="empty-state d-flex flex-column align-items-center text-center gap-2 py-5 px-3">
  <mat-icon class="empty-icon" aria-hidden="true">{{ icon() }}</mat-icon>

  <p class="empty-title m-0">{{ title() }}</p>

  @if (message()) {
    <p class="empty-message m-0">{{ message() }}</p>
  }
</div>
